import React, { useEffect } from 'react';
import { Row, Col } from 'antd';
import Fieldset from '../Fieldset/Fieldset';
import UploadDocField from '../UploadDocField/UploadDocField';
import SelectDocDateField from '../SelectDocDateField/SelectDocDateField';
import SelectDocTypeField from '../SelectDocTypeField/SelectDocTypeField';
import DocNameField from '../DocNameField/DocNameField';
import { formConfig } from '../../../../config';

const { docFieldNames } = formConfig;

const DocFieldset = ({ form, fileList, setFileList }) => {
  useEffect(() => {
    form.validateFields(Object.values(docFieldNames), { force: true });
  }, [fileList]);

  const required = Boolean(fileList?.length);

  return (
    <Fieldset
      legend="Добавление документа"
      legendProps={{ style: { marginBottom: '10px' } }}
    >
      <Row>
        <Col span={24}>
          <UploadDocField
            form={form}
            fileList={fileList}
            setFileList={setFileList}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <SelectDocDateField
            form={form}
            required={required}
          />
        </Col>
        <Col span={16}>
          <SelectDocTypeField
            form={form}
            required={required}
          />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <DocNameField
            form={form}
            required={required}
          />
        </Col>
      </Row>
    </Fieldset>
  );
};

export default DocFieldset;
